import { Component, OnInit } from '@angular/core';
import { TranslateService,LangChangeEvent } from '@ngx-translate/core';
import { CoreService } from '../../../../../service/core.service';
import { ApiService } from '../../../../../service/api.service';
import { Sales } from '../../../../../model/report/sales.model';
import * as XLSX from 'xlsx';
import { CurrencyPipe } from '@angular/common';
import { ExcelService } from '../../../../../service/excel.service';

@Component({
  selector: 'app-rep-stock-aging',
  templateUrl: './rep-stock-aging.component.html',
  styleUrls: ['./rep-stock-aging.component.css']
})
export class RepStockAgingComponent implements OnInit {
  fileName = 'stock_aging.xlsx';
  pageLoadingImg: boolean;
  summary: any;
  repDate: any;
  total_bal_amnt: any;
  total_due: any;
  opening_balnce: any;
  total_out: any;
  atot: any;
  btot: any;
  dtot: any;
  ctot: any;
  etot: any;
  ftot: any;
  showfull: any;
  pageFrom: any;
  curpage: any;
  lastpage: any;
  totalData: any;
  pgend: boolean;
  pgstart: boolean;
  filter_types = [
    { id: 't', name: 'Today' },
    { id: 'ld', name: 'Last Day' },
    { id: 'lw', name: 'Last week' },
    { id: 'lm', name: 'Last Month' },
    { id: 'ly', name: 'Last Year' },
    { id: 'c', name: 'Custom Date' },
    { id: '', name: 'All' }

  ];
  userType: any;
  branch_all: any;
  filter_branch_id: any;
  cur_lang: string;
  products:any;
  exportLoader: boolean;
  exclude_zero=false;
  Expshow: Sales;
  Expsummary: any;
  Exptotal_bal_amnt: any;
  ExprepDate: any;
  Expopening_balnce: any;
  Exptotal_out: any;
  Exptotal_due: any;
  Expatot: any;
  Expbtot: any;
  Expctot: any;
  Expdtot: any;
  Expetot: any;
  Expftot: any;
  Expshowfull: any;
  branch_display_name: any;
  branch_name: any;
  branch_display_code: any;
  branch_address: any;
  country_dec: number=2;

  constructor(private apiService: ApiService, private coreService: CoreService,private translate: TranslateService,private excelService: ExcelService,private currencyPipe: CurrencyPipe) { }

  ngOnInit() {
    this.cur_lang = sessionStorage.getItem("baseLang");
    this.apiService.cur_lang.subscribe(value =>{
      this.cur_lang = value;
    })
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langChange();
    });
    this.langChange();
    // this.display_type = '1';

    this.userType = this.coreService.getUserData('user_type');
    this.filter_branch_id = 1;
    this.getAllBranch();
    this.branch_display_name = this.coreService.getUserData('branch_disp_name');
    this.branch_name = this.coreService.getUserData('branch_name');
    this.branch_display_code = this.coreService.getUserData('branch_code');
    this.branch_address = this.coreService.getUserData('branch_address');

    this.country_dec=this.coreService.setDecimalLength();
    
    this.totalData = 0;
    this.pageLoadingImg = true;
    let searchval = new FormData();
    searchval.append("filter_branch_id", this.filter_branch_id);
    this.apiService.stockAgingReports(searchval, 1).subscribe((res: Sales) => {
      this.pageLoadingImg = false;
    
      // this.show = res['data'];
      console.log("shameer111");
      // console.log(this.show);

     console.log('res',res);


      this.summary = res['data']['data'];
      this.repDate = res['data']['Date'];
      this.total_bal_amnt = res['data']['total_bal_amnt'];
      this.opening_balnce = res['data']['opening_balnce'];
      this.total_due = res['data']['total_due'];
   
      this.total_out = res['data']['totTotalAllOut'];
      // this.van_route = res['van_route'];
      // this.vanName =res['vanName'];
      this.atot = res['data']['atot'];
      this.btot = res['data']['btot'];
      this.ctot = res['data']['ctot'];
      this.dtot = res['data']['dtot'];
      this.etot = res['data']['etot'];
      this.ftot = res['data']['ftot'];
      this.pageFrom = res['data']['from'];
      this.curpage = res['data']['current_page'];
      this.lastpage = res['data']['last_page'];
      this.totalData = res['data']['total'];
      console.log(this.totalData);
      this.showfull = res['data']['showall'];
      this.pgEnd(this.curpage, this.lastpage);
      this.pgStart(this.curpage);
     
    });

  }

    pageNext(formdata: { value: any; }, newform: { value: any; }, pageno: any) {
      console.log("gggggggg");
      console.log(formdata.value.period_type);
      this.pageLoadingImg = true;
     // formdata.value.datewise = newform.value.datewise;
      if (formdata.value.period_type === 'c') {
        formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
        formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
        formdata.value.time1 = (formdata.value.time1) ? this.apiService.formatTime(formdata.value.time1) : formdata.value.time1;
        formdata.value.time2 = (formdata.value.time2) ? this.apiService.formatTime(formdata.value.time2) : formdata.value.time2;
      }
      this.apiService.stockAgingReports(formdata.value, pageno).subscribe((res: Sales) => {
        this.pageLoadingImg = false;
      
        // this.show = res['data'];
        console.log("shameer111");
        // console.log(this.show);
  
       console.log('res',res);
  
  
        this.summary = res['data']['data'];
        this.repDate = res['data']['Date'];
        this.total_bal_amnt = res['data']['total_bal_amnt'];
        this.opening_balnce = res['data']['opening_balnce'];
        this.total_due = res['data']['total_due'];
     
        this.total_out = res['data']['totTotalAllOut'];
        // this.van_route = res['van_route'];
        // this.vanName =res['vanName'];
        this.atot = res['data']['atot'];
        this.btot = res['data']['btot'];
        this.ctot = res['data']['ctot'];
        this.dtot = res['data']['dtot'];
        this.etot = res['data']['etot'];
        this.ftot = res['data']['ftot'];
        this.pageFrom = res['data']['from'];
        this.curpage = res['data']['current_page'];
        this.lastpage = res['data']['last_page'];
        this.totalData = res['data']['total'];
        console.log(this.totalData);
        this.showfull = res['data']['showall'];
        this.pgEnd(this.curpage, this.lastpage);
        this.pgStart(this.curpage);
       
      });
  
    }
    pgEnd(curr, end) {
      if (curr == end)
        this.pgend = true;
      else
        this.pgend = false;
  
    }
  
    pgStart(curr) {
      if (curr == 1)
        this.pgstart = true;
      else
        this.pgstart = false;
    }

    langChange(){
      this.translate.get(['Common.today', 'Common.last_day','Common.last_week', 'Common.last_maonth','Common.last_yr', 'Common.cust_date','Common.all']).subscribe((res: string) => {    
       
        
        this.filter_types = [
          
      { id: 't', name: res['Common.today'] },
      { id: 'ld', name: res['Common.last_day'] },
      { id: 'lw', name: res['Common.last_week'] },
      { id: 'lm', name: res['Common.last_maonth'] },
      { id: 'ly', name: res['Common.last_yr'] },
      { id: 'c', name: res['Common.cust_date'] },
      { id: '', name: res['Common.all'] }
          
        ];
      });
  
    }
    getAllBranch() {
      this.apiService.readAllBranch().subscribe((res) => {
        this.branch_all = res['data'];
        // this.filter_branch_id = res['selected'];
    
        // if (this.userType == 'ADMIN') {
        //   this.branch_all.push({ 'branch_id': 'All', 'branch_name': 'All Branch', 'branch_display_name': 'All Branch' })
        // }
      });
    }
    
    searchBranch(search: string) {
      let searchval = new FormData();
      searchval.append("branch_name", search);
      this.apiService.getBranchByName(searchval).subscribe((res) => {
        this.branch_all = res['data'];
        // if (this.userType == 'ADMIN') {
        //   this.branch_all.push({ 'branch_id': 'All', 'branch_name': 'All Branch', 'branch_display_name': 'All Branch' })
        // }
      });
    }
    selectProd(name: string) {

      const searchval = new FormData();
      searchval.append('prod_name', name);
      if(this.cur_lang !=undefined && this.cur_lang !=null && this.cur_lang !='English' ){
        searchval.append('alias_search', '1');
      }
      this.apiService.getProdByName(searchval).subscribe((res) => {
        this.products = res.data;
      });
    }

      exportexcel(): void {
        /* table id is passed over here */
        let element = document.getElementById('export-group');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    
        /* save to file */
        XLSX.writeFile(wb, this.fileName);
        this.exportLoader = false;
    
      }
    exportEXCL(Expformdata: { value: any; }) {

      // debugger;
      this.exportLoader = true;
  
      Expformdata.value.datewise = true;
      Expformdata.value.export = 'export';
      Expformdata.value.exclude_zero = this.exclude_zero;
      if (Expformdata.value.period_type === 'c') {
        Expformdata.value.date1 = (Expformdata.value.date1) ? this.apiService.formatDate(Expformdata.value.date1) : Expformdata.value.date1;
        Expformdata.value.date2 = (Expformdata.value.date2) ? this.apiService.formatDate(Expformdata.value.date2) : Expformdata.value.date2;
        Expformdata.value.time1 = (Expformdata.value.time1) ? this.apiService.formatTime(Expformdata.value.time1) : Expformdata.value.time1;
        Expformdata.value.time2 = (Expformdata.value.time2) ? this.apiService.formatTime(Expformdata.value.time2) : Expformdata.value.time2;
      }
      this.apiService.stockAgingReports(Expformdata.value, 1).subscribe((res: Sales) => {
        // if(res['data']['data']){
        this.Expshow = res;
  
        console.log("shameer3333");
        console.log(this.Expshow);
  
        this.Expsummary = res['data']['data'];
        this.ExprepDate = res['data']['Date'];
        this.Exptotal_bal_amnt = res['data']['total_bal_amnt'];
        this.Expopening_balnce = res['data']['opening_balnce'];
        this.Exptotal_due = res['data']['total_due'];
        this.Exptotal_out = res['data']['totTotalAllOut'];
      //  this.ExpvanName =res['vanName'];
        this.Expatot = res['data']['atot'];
        this.Expbtot = res['data']['btot'];
        this.Expctot = res['data']['ctot'];
        this.Expdtot = res['data']['dtot'];
        this.Expetot = res['data']['etot'];
        this.Expftot = res['data']['ftot'];
        this.Expshowfull = res['data']['showall'];
  
        // }
  
  
        setTimeout(() => {
          this.exportexcel();
        }, 3000);
  
        Expformdata.value.export = '';
  
  
      });
  
  
  
    }
  

}
